import {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Collapse, IconButton, LinearProgress, Paper,
    Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Tooltip,
} from '@material-ui/core';
import qs from 'qs';
import moment from 'moment';
import {ErrorGeneral, llamadaApiToken} from '../funciones/ClienteAxios';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LocationOnIcon from "@material-ui/icons/LocationOn";
import ModalMapa from "./ModalMapa";
import CreateIcon from '@material-ui/icons/Create';
import ModalEdit from './ModalEdit';
const useStyles = makeStyles(theme=>({
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: theme.palette.secondary.main
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
}));

export default function TablaAfiliados({ history, fechasSeleccionadas, selectedID, setSelectedID, source,
                                            idusu, buscar, checked, abrirModal, setAbrirModal, setRecorrido,
                                            muni, secc, distrito, auxIp, listMun
                                        }) {
    const classes = useStyles();
    const [espera, setEspera] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [modalEditar, setModalEditar] = useState(false)
    const [sinDatos, guardarSinDatos] = useState(true)
    const [open, setOpen] = useState(false);
    const [seleccionado, setSeleccionado] = useState([]);
    let fInicio = moment(fechasSeleccionadas.inicio).format("YYYY-MM-DD")
    let fFinal = moment(fechasSeleccionadas.final).format("YYYY-MM-DD")
    let filter = 0


    useEffect(() => {
        const llenarTabla = () => {
            setEspera(true)
            if (checked) {
                filter = idusu
            } else {
                filter = 0
            }

            const data = qs.stringify({
                Usuario: idusu,
                Estado:13,
                Muni:muni !== "" && muni !== 0 ? muni.Id :0,
                Seccion:secc !== "" && secc !== 0  ? secc :0,
                DFed:0,
                DLoc:0,
                FIni: fInicio + 'T00:00:00',
                FFin: fFinal + 'T23:59:59',
                ip:auxIp,
                idDispositivo: '45vf2d1vdf21d2f'
            });
            const url = "afiliacion/list";

            function response(data) {
                if (data[0].Id != -1) {
                    guardarSinDatos(true)
                    guardarDatos(data)
                    setEspera(false)
                } else {
                    guardarSinDatos(false)
                    setEspera(false)
                }
            }

            llamadaApiToken(data, url, response, ErrorGeneral, history, source);
        };

        llenarTabla();
    }, [buscar]);

    const seleccionar = (auxId, auxOrden) => {
        setSelectedID(auxId)
        setRecorrido(auxOrden)
        setSeleccionado(auxOrden)
    }

    const abrirModalMapa = () => {
        setAbrirModal(true)
    }

    const etiqGen =(genero)=>{
        let valor=""
        if (genero==="H") 
        {
            valor="Hombre"
        }
        else 
        {   if (genero==="M") 
            {
                valor="Mujer"
            }
            else 
            {   if (genero==="B") 
                {
                    valor="Binario"
                }
                else 
                {   if (genero==="N") 
                    {
                        valor="No Binario"
                    }
                }
            }
        }
        return valor
    }

    const modalMapa = abrirModal ? <ModalMapa abrirModal={abrirModal}
                                        setAbrirModal={setAbrirModal}  datos={seleccionado}
                                    /> : null

    function verMas(auxId) {
        setSelectedID(auxId)
        if (auxId === selectedID) {
            setOpen(!open)
        } else {
            setOpen(false)
        }
    }

    function obtDireccion(elemento) {
        let respuesta=""
        if (elemento.Calle) {
            respuesta = `${elemento.Calle} `
        }
        if (elemento.NExt!==0 && elemento.NExt!=="" && elemento.NExt!=="0" ) {
            
            if (elemento.NInt !==0 && elemento.NInt!=="" && elemento.NInt!=="0" ) {
                respuesta = `${respuesta} Ext. ${elemento.NExt}  Int. ${elemento.NInt}, `
            }
            else{
                respuesta = `${respuesta} Ext. ${elemento.NExt}, `
            }
        }
        else{
            respuesta = `${respuesta}, `
        }
        if (elemento.Col) {
            respuesta = `${respuesta} ${elemento.Col}, `
        }
        if (elemento.Cp) {
            respuesta=`${respuesta} ${elemento.Cp} `
        }
        if (elemento.MunNom) {
            respuesta=`${respuesta} ${elemento.MunNom}, Hgo `
        }
        return respuesta
    }

    function Row(props) {
        const {row} = props;
        const auxEdit=  <Tooltip title={`Editar Perfil`}>
            <IconButton   aria-label="add circle" size="small" 
                onClick={() => setModalEditar(row)} component="span">
                {selectedID === row.Id ? 
                    <CreateIcon style={{color:'white',width:18+'px'}} />
                    :<CreateIcon style={{width:18+'px'}} color="primary"/>
                }
                </IconButton>                            
            </Tooltip>   
        return (
        <>
            <TableRow onClick={() => { seleccionar(row.Id, row) }}
                className={classes.tableRow} selected={selectedID === row.Id}
                classes={{hover: classes.hover, selected: classes.selected}}
            >                                       
                {/* <TableCell align="center" padding={'none'} style={{width: 30}}>
                    {row.Obsrv.length !== 0 ?
                        <Tooltip title={open && selectedID === row.Id ? 'Ver menos' : 'Ver más'}>
                            <IconButton color="primary" aria-label="expand row" size="small"
                                onClick={() => verMas(row.Id)}>
                                {open && selectedID === row.Id ?
                                    (selectedID === row.Id ?
                                        <KeyboardArrowUpIcon style={{color: 'white'}}/>
                                        : <KeyboardArrowUpIcon/>)
                                    : (selectedID === row.Id ?
                                        <KeyboardArrowDownIcon style={{color: 'white'}}/>
                                        : <KeyboardArrowDownIcon/>)}
                            </IconButton>
                        </Tooltip>
                        : null}
                </TableCell> */}
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={75}
                    style={{fontSize: 12 + 'px'}} >
                    {auxEdit}
                </TableCell>
                {row.Lat && row.Lon !== 0.0 ?
                    <TableCell align="center" padding={'none'} style={{width: 30}}>
                        <Tooltip title={'Ver más'}>
                            <IconButton color="primary" size="small"
                                onClick={() => abrirModalMapa()}>
                                {selectedID === row.Id ?
                                    <LocationOnIcon style={{color: 'white'}}/> 
                                    : <LocationOnIcon/>}
                            </IconButton>
                        </Tooltip>
                    </TableCell> 
                    : <TableCell align="center" padding={'none'} style={{width: 30}}></TableCell>
                }

                <TableCell className={classes.tableCell} align="center" padding={'none'} width={75}
                    style={{fontSize: 12 + 'px'}} >
                    {moment.utc(row.FReg).local(true).format("DD/MM/YYYY HH:mm")}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={75}
                    style={{fontSize: 12 + 'px'}} >
                    {moment.utc(row.FEnv).local(true).format("DD/MM/YYYY HH:mm")}
                </TableCell>
                <TableCell className={classes.tableCell} align="left" padding={'none'} width={180}
                    style={{fontSize: 12 + 'px'}} >
                    {`${row.Nom} ${row.Pat} ${row.Mat}`}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={120} >
                    {row.Tel}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={120} >
                    {row.Cel}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={80}
                    style={{fontSize: 12 + 'px'}} >
                    {row.Ine}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={50}
                    style={{fontSize: 12 + 'px'}} >
                    {etiqGen(row.Gen)}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={100}
                    style={{fontSize: 10 + 'px'}} >
                    {row.MunNom}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={55} >
                    {row.SecNom}
                </TableCell>
                <TableCell className={classes.tableCell} align="left" padding={'none'} style={{fontSize: 12 + 'px'}}
                     width={220}>
                    {obtDireccion(row)}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={9}>
                    <Collapse in={open && selectedID === row.Id && row.Obsrv.length !== 0} timeout="auto"
                        unmountOnExit>
                        <Box margin={1}>
                        <Table size="small" aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    <TableCell padding={'none'}> Observación </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow key={row.Id}>
                                    <TableCell padding={'none'}> {row.Obsrv}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
        );
    }

    function tablaCompleta(auxlista) {
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" padding='none'></TableCell> 
                    <TableCell align="center" padding='none'>{auxlista.length}</TableCell>                            
                    <TableCell align="center" padding='none'>Fecha Sistema</TableCell>
                    <TableCell align="center" padding='none'>Fecha Afiliación</TableCell>
                    <TableCell align="center" padding='none'>Nombre</TableCell>
                    <TableCell align="center" padding='none'>Teléfono</TableCell>
                    <TableCell align="center" padding='none'>Celular</TableCell>                    
                    <TableCell align="center" padding='none'>Credencial Elector</TableCell>
                    <TableCell align="center" padding='none'>Género</TableCell>
                    <TableCell align="center" padding='none'>Municipio</TableCell>
                    <TableCell align="center" padding='none'>Sección</TableCell>
                    <TableCell align="center" padding='none'>Dirección</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length != 0 ? (auxlista.map((row) => (
                    <Row key={row.Id} row={row}/>
                ))) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
            <TableContainer className={classes.container2}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" padding='none'></TableCell>
                            <TableCell align="center" padding='none'>Fecha Sistema</TableCell>
                            <TableCell align="center" padding='none'>Fecha Afiliación</TableCell>
                            <TableCell align="center" padding='none'>Nombre</TableCell>
                            <TableCell align="center" padding='none'>Teléfono</TableCell>
                            <TableCell align="center" padding='none'>Celular</TableCell>
                            <TableCell align="center" padding='none'>Credencial Elector</TableCell>
                            <TableCell align="center" padding='none'>Municipio</TableCell>
                            <TableCell align="center" padding='none'>Sección</TableCell>
                            <TableCell align="center" padding='none'>Dirección</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableCell} align="center">Dia</TableCell>
                            <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                            <TableCell className={classes.tableCell} align="left">Afiliados</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const modEdit = modalEditar ? <ModalEdit abrirModal={modalEditar} auxIp={auxIp} listMun={listMun}
                setAbrirModal={setModalEditar} afiliado={seleccionado} actualiza={()=>{}} /> : null
    const contenido = sinDatos && datos.length != 0 ? tablaCompleta(datos) : tablaSinDatos()
    const tabla = espera ? (<Box mt={2}><LinearProgress/> </Box>) : (contenido)

    return (
    <Paper>
        {modEdit}
        {tabla}
        {modalMapa}
    </Paper>
    );
}